// Suppress ResizeObserver loop error in development
if (process.env.NODE_ENV === "development") {
  const realConsoleError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("ResizeObserver loop completed")
    ) {
      return;
    }
    realConsoleError(...args);
  };
}

import { createApp } from "vue";
import App from "./App.vue";
import i18n from "../i18n";
import "./registerServiceWorker";
import router from "./router";
import "./assets/index.scss";
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import casl from "./plugins/casl";
import { authCookies } from "./services/cookies";
import { updateAbility } from "./abilities/ability";

updateAbility(authCookies.getPermissions());

const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  console.error("Error: ", err);
  console.error("Info: ", info);
  router.push({
    name: "ErrorPage",
    params: { errorMessage: err.message || "An unknown error occurred" },
  });
};

app.use(router).use(i18n).use(VueAwesomePaginate).use(casl).mount("#app");
